'use client'

import { createContext, PropsWithChildren, useContext } from 'react'

import { cn } from '@/lib/cn'
import { UseDataTableReturn } from './use-data-table'

const DataTableContext = createContext<UseDataTableReturn | null>(null)

export function DataTableRoot({
  table,
  children,
}: PropsWithChildren<{ table: UseDataTableReturn }>) {
  return (
    <DataTableContext.Provider value={table}>
      <div className={cn('flex flex-col gap-2.5 overflow-auto')}>
        {children}
      </div>
    </DataTableContext.Provider>
  )
}

export function useDataTableContext() {
  const context = useContext(DataTableContext)

  if (!context) {
    throw new Error('useDataTableContext must be used within a DataTableRoot')
  }

  return context
}
